import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";

export default function HlsPlayer({ src, onStatusChange }) {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    setError(null);
    if (onStatusChange) onStatusChange(true);

    // If HLS.js is supported (Chrome, Firefox, Edge)
    if (Hls.isSupported()) {
      // Destroy previous instance if changing stream
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }

      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 90,
      });

      hlsRef.current = hls;

      hls.loadSource(src);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, function (event, data) {
        console.error("HLS.js error:", data);
        if (data.fatal) {
          setError(`Fatal HLS error: ${data.type} — ${data.details}`);
          if (onStatusChange) onStatusChange(false);
        }
      });
    }
    // Native HLS support fallback (Safari, iOS)
    else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
    } else {
      setError("HLS is not supported in this browser.");
      if (onStatusChange) onStatusChange(false);
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [src]);

  return (
    <div>
      <video
        ref={videoRef}
        controls
        autoPlay
        muted
        style={{
          width: "100%",
          height: "auto",
          background: "black",
          display: error ? "none" : "block",
        }}
      ></video>
      {error && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 24px',
          background: 'var(--bg-subtle)',
          border: '1px solid var(--border-color)',
          borderRadius: '10px',
          textAlign: 'center',
        }}>
          <i className="fa fa-video-camera" style={{ fontSize: '2.5rem', color: 'var(--text-muted)', marginBottom: '12px' }}></i>
          <div style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px' }}>
            Livestream nicht verfügbar
          </div>
          <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            Der Videostream ist derzeit nicht erreichbar. Bitte versuche es später erneut.
          </div>
        </div>
      )}
    </div>
  );
}
